import { Project } from "@docma-mm-core/project/project";
import { ProjectRole } from "@docma-mm-core/role/role";
import { Shortcut } from "@docma-mm-core/shortcut/shortcut";
import { User } from "@docma-mm-core/user/user";
import { ConfigPermission } from "./config-permission";
import { ProjectActionPermissionEnum } from "./project-action-permission.enum";
import { ActionPermissionEnum } from "@docma-mm-core/permission/action-permission.enum";

export class ProjectUserPermissions {
  Project?: Project;
  Actions?: ProjectActionPermissionEnum[];
  AdminActions?: ActionPermissionEnum[];
  Configs?: ConfigPermission [];
  Shortcuts?: Shortcut [];
  User?: User;
  ProjectRole?: ProjectRole;
}
